import React from 'react';
export const LodgeMappingContext = React.createContext({
  lodgeMapping: null,
  exchange: null,
});
LodgeMappingContext.displayName = 'LodgeMappingContext';
